import type { FC, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { experimentalStyled } from '@material-ui/core/styles';
import DashboardSidebar from './DashboardSidebar';
import ChatWidget from '../chat/ChatWidget';
import { Header } from '../Header';
// import DashboardNavbar from './DashboardNavbar';

interface DashboardLayoutProps {
  children?: ReactNode;
}

const DashboardLayoutRoot = experimentalStyled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  height: '100%',
  overflow: 'hidden',
  width: '100%',
  flexDirection: 'column'
}));

// const DashboardLayoutWrapper = experimentalStyled('div')(() => ({
//   display: 'flex',
//   flex: '1 1 auto',
//   overflow: 'hidden',
//   // paddingTop: '100px',
// }));

const DashboardLayoutContainer = experimentalStyled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
});

const DashboardLayoutContent = experimentalStyled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto',
  position: 'relative',
  WebkitOverflowScrolling: 'touch',
});

const DashboardLayout: FC<DashboardLayoutProps> = () => (
  <DashboardLayoutRoot>
    {/* Global header above sidebar and content */}
    <Header />

    {/* Row: sidebar + content */}
    <div
      style={{
        display: 'flex',
        flex: '1 1 auto',
        minHeight: 0, // allow inner area to control scroll
        overflow: 'hidden'
      }}
    >
      <DashboardSidebar />

      <DashboardLayoutContainer>
        <DashboardLayoutContent>
          <div style={{ backgroundColor: '#F7FAFC' }}>
            <Outlet />
          </div>
        </DashboardLayoutContent>
      </DashboardLayoutContainer>
    </div>

    <ChatWidget />
  </DashboardLayoutRoot>
);
export default DashboardLayout;
